<template>
  <div class="container">
    <div class="page-header__content  pb-10 xxl:pb-90 position-relative">
      <div class="row y-gap-30" data-aos="fade-up" :data-aos-delay="200">
        <div class="col-xl-8 col-lg-8">
          <div>
            <figure>
              <!----<video controls class="rounded-5">
                <source src="../../assets/images/home/video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>-->
              <div class="course-headingimage">
                <img :src="courseItem?.preview_image" class="img-fluid">
              </div>
              <figcaption class="sr-only">
                A brief description of the video content, such as "Promotional video for our new product line."
              </figcaption>
            </figure>

            <div class="d-none">
              <span class="fw-400 d-inline-block pt-1 bg-danger text-light"
                v-if="courseItem?.pricing[0]?.original_price - courseItem?.pricing[0]?.price !== 0 && !courseItem?.pricing[0]?.is_free && item?.pricing[0]?.price !== 0 && courseItem?.pricing.length > 0">
                {{ ((courseItem?.pricing[0]?.original_price - courseItem?.pricing[0]?.price) /
                  courseItem?.pricing[0]?.original_price * 100).toFixed(2) }} % Off
              </span>
              <span class="fw-400 d-inline-block pt-1 bg-danger capitalize text-light"
                v-if="courseItem?.pricing[0]?.price === 0 || courseItem?.pricing.length === 0">
                Free
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="courses-single-info" :class="{ 'fixed-info': isFixed && isMenuVisible }" ref="courseInfo"
      :style="{ top: windowWidth < 992 ? '0px' : (activePromotion ? '230px' : '100px') }" data-aos="fade-up"
      :data-aos-delay="200">
      <div class="rounded-8 py-10 px-10">
        <div class="relative text-capitalize">
          <h1> {{ courseItem?.title }}</h1>

          <div class="d-flex gap-3 d-inline-flex align-items-center mt-12 course-level"
            v-if="!courseItem?.enrollment['is_enrolled']">
            <span class="d-inline-block fw-400 pt-1" v-if="courseItem?.course_type === 'INTERACTIVE_SESSION'"> {{
              $t('courseType.interactiveSession') }}</span>
            <span class="d-inline-block fw-400 pt-1" v-if="courseItem?.course_type === 'OFFLINE_COURSE'"> {{
              $t('courseType.offlineCourse') }} </span>
            <span class="d-inline-block fw-400 pt-1">
              Expires in {{ courseItem?.options['expire_in_months'] }} month
            </span>
          </div>

          <div class="d-flex gap-1 teacher d-inline-flex align-items-center pt-10">
            <span class="d-inline-block">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                  stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                <path
                  d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                  stroke="#94AD04" stroke-width="1.5" />
              </svg>
            </span>
            <span class="fw-500 d-inline-block pt-1 text-secondary">
              {{ courseItem?.teacher.name }}
            </span>
          </div>

          <div class="d-flex items-center mt-10" v-if="courseItem?.reviews_summery?.average_rating">
            <!--- v-if="courseItem?.enrollment.review" -->
            <!--<div class="text-14 lh-1 text-yellow-1 mr-10">4.5</div>-->
            <div class="d-flex x-gap-5 items-center">
              <rating-component :rating="courseItem?.reviews_summery?.average_rating"></rating-component>
            </div>
            <!----<div class="text-13 lh-1 ml-10 course-info exprience"> {{courseItem?.reviews_summery.total_reviews}}</div>-->
          </div>
        </div>

        <div class="courses-single-info__content pt-15 pb-15" v-if="!courseItem?.enrollment['is_enrolled']">
          <div class="">
            <div class="d-flex justify-between py-10">
              <div class="d-flex items-center text-dark-1">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M20 3H4C3.45 3 3 3.45 3 4V20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20V4C21 3.45 20.55 3 20 3ZM9 7H7V9H9V7ZM16 9H12C11.45 9 11 8.55 11 8C11 7.45 11.45 7 12 7H16C16.55 7 17 7.45 17 8C17 8.55 16.55 9 16 9ZM16 13H12C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13ZM12 17H16C16.55 17 17 16.55 17 16C17 15.45 16.55 15 16 15H12C11.45 15 11 15.45 11 16C11 16.55 11.45 17 12 17ZM7 11H9V13H7V11ZM9 15H7V17H9V15ZM5 19H19V5H5V19Z"
                      fill="#09445D" />
                  </svg>
                </span>
                <div class="ml-10 course-info"> {{ courseItem?.options['chapter_count'] }} {{ $t('chapter_count') }}
                </div>
              </div>
            </div>

            <div class="d-flex justify-between py-10">
              <div class="d-flex items-center text-dark-1">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M21 3.5H3C1.9 3.5 1 4.4 1 5.5V18.5C1 19.6 1.9 20.5 3 20.5H21C22.1 20.5 23 19.6 23 18.5V5.5C23 4.4 22.1 3.5 21 3.5ZM21 17.5C21 18.05 20.55 18.5 20 18.5H12V5.5H20C20.55 5.5 21 5.95 21 6.5V17.5ZM13.75 9H19.25C19.66 9 20 9.34 20 9.75C20 10.16 19.66 10.5 19.25 10.5H13.75C13.34 10.5 13 10.16 13 9.75C13 9.34 13.34 9 13.75 9ZM19.25 11.5H13.75C13.34 11.5 13 11.84 13 12.25C13 12.66 13.34 13 13.75 13H19.25C19.66 13 20 12.66 20 12.25C20 11.84 19.66 11.5 19.25 11.5ZM13.75 14H19.25C19.66 14 20 14.34 20 14.75C20 15.16 19.66 15.5 19.25 15.5H13.75C13.34 15.5 13 15.16 13 14.75C13 14.34 13.34 14 13.75 14Z"
                      fill="#09445D" />
                  </svg>
                </span>
                <div class="ml-10 course-info"> {{ courseItem?.options['lecture_count'] }} {{ $t('lecture_count') }}
                </div>
              </div>
            </div>

            <div class="d-flex justify-between py-10">
              <div class="d-flex items-center text-dark-1">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M21 5.90001H13.41L16.35 2.96001C16.55 2.76001 16.55 2.45001 16.35 2.25001C16.15 2.05001 15.84 2.05001 15.64 2.25001L12 5.89001L8.36 2.25001C8.16 2.05001 7.85 2.05001 7.65 2.25001C7.45 2.45001 7.45 2.76001 7.65 2.96001L10.59 5.90001H3C1.9 5.90001 1 6.79001 1 7.90001V19.9C1 21 1.9 21.9 3 21.9H21C22.1 21.9 23 21 23 19.9V7.90001C23 6.79001 22.1 5.90001 21 5.90001ZM10.5 17.05L14.48 14.77C15.15 14.39 15.15 13.42 14.48 13.03L10.5 10.75C9.83 10.37 9 10.86 9 11.62V16.17C9 16.94 9.83 17.43 10.5 17.05ZM4 19.9H20C20.55 19.9 21 19.45 21 18.9V8.90001C21 8.35001 20.55 7.90001 20 7.90001H4C3.45 7.90001 3 8.35001 3 8.90001V18.9C3 19.45 3.45 19.9 4 19.9Z"
                      fill="#09445D" />
                  </svg>
                </span>
                <div class="ml-10 course-info">
                  {{ Math.floor(courseItem?.options['lecture_time_estimate_sec'] / 3600) }} {{ $t('hours') }}
                  {{ Math.floor((courseItem?.options['lecture_time_estimate_sec'] % 3600) / 60) }} {{ $t('mins') }}
                </div>
              </div>
            </div>

            <!----<div class="d-flex justify-between py-10">
              <div class="d-flex items-center text-dark-1">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14 4.65181V4.45181C14 3.82181 14.63 3.37181 15.21 3.60181C18.6 4.89181 21 8.16181 21 12.0018C21 15.8418 18.6 19.1118 15.21 20.4018C14.63 20.6218 14 20.1818 14 19.5518V19.3518C14 18.9718 14.24 18.6418 14.6 18.5018C17.18 17.4718 19 14.9418 19 12.0018C19 9.06181 17.18 6.53181 14.6 5.50181C14.25 5.36181 14 5.03181 14 4.65181ZM3 10.0018V14.0018C3 14.5518 3.45 15.0018 4 15.0018H7L10.29 18.2918C10.92 18.9218 12 18.4718 12 17.5818V6.41181C12 5.52181 10.92 5.07181 10.29 5.70181L7 9.00181H4C3.45 9.00181 3 9.45181 3 10.0018ZM16.5 12.0018C16.5 10.2318 15.48 8.71181 14 7.97181V16.0218C15.48 15.2918 16.5 13.7718 16.5 12.0018Z"
                      fill="#09445D" />
                  </svg>
                </span>

                <div class="ml-10 course-info">{{ courseItem?.options.language }}</div>
              </div>
            </div>-->

            <div class="py-10 d-flex items-center justify-between text-dark-1">
              <span>
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="#09445D" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m7.171 12.906-2.153 6.411 2.672-.89 1.568 2.34 1.825-5.183m5.73-2.678 2.154 6.411-2.673-.89-1.568 2.34-1.825-5.183M9.165 4.3c.58.068 1.153-.17 1.515-.628a1.681 1.681 0 0 1 2.64 0 1.68 1.68 0 0 0 1.515.628 1.681 1.681 0 0 1 1.866 1.866c-.068.58.17 1.154.628 1.516a1.681 1.681 0 0 1 0 2.639 1.682 1.682 0 0 0-.628 1.515 1.681 1.681 0 0 1-1.866 1.866 1.681 1.681 0 0 0-1.516.628 1.681 1.681 0 0 1-2.639 0 1.681 1.681 0 0 0-1.515-.628 1.681 1.681 0 0 1-1.867-1.866 1.681 1.681 0 0 0-.627-1.515 1.681 1.681 0 0 1 0-2.64c.458-.361.696-.935.627-1.515A1.681 1.681 0 0 1 9.165 4.3ZM14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
                </svg>
              </span>
              <div class="ml-10 course-info d-flex justify-content-between w-100">
                <span class="d-block"> {{ $t('certification') }} </span>
                <span> {{ courseItem?.options['has_certification'] ? $t('yes') : $t('no') }} </span>
              </div>
            </div>


            <div class="d-flex gap-3 d-inline-flex mb-10 align-items-center py-10 x-gap-5 price"
              v-if="courseItem?.pricing.length !== 0">
              <span class=" pt-1"
                :class="courseItem?.pricing[0]?.original_price - courseItem?.pricing[0]?.price !== 0 ? ' price-orginial fw-700  text-20' : 'd-none'">{{
                  courseItem?.pricing[0]?.price}} {{ courseItem?.pricing[0]?.currency }}</span>
              <span class="d-inline-block pt-1  discount"
                :class="courseItem?.pricing[0]?.original_price - courseItem?.pricing[0]?.price !== 0 ? 'exprience fw-400  text-16 line-through' : 'price-orginial fw-700  text-20'">
                {{ courseItem?.pricing[0]?.original_price }} {{ courseItem?.pricing[0]?.currency }}
              </span>
            </div>

            <div class="d-flex gap-3 d-inline-flex py-10 mb-10" v-if="courseItem?.pricing.length === 0">
              <span class="  price-orginial fw-700  text-20 " v-if="courseItem?.pricing.length === 0"> 0.00 USD </span>
            </div>
          </div>

          <div class="coupon sidebar-recent">
            <h5 class="mb-15">{{ $t('coupon') }}</h5>
            <form class="d-flex justify-content-between align-items-center gap-10 flex-column flex-md-row"
              @submit.prevent="sendCoupon">
              <input type="text" class="form-control rounded-8" :placeholder="$t('enter-coupon')"
                v-model="couponCode" />
              <button type="submit" class="button  capitalize ">
                {{ $t('apply') }}
              </button>
            </form>
          </div>

          <div class="d-flex align-items-center gap-2">
            <!----<button class="favorite">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 5.96581L11.46 6.48581C11.53 6.55839 11.6138 6.61613 11.7066 6.65556C11.7994 6.695 11.8992 6.71532 12 6.71532C12.1008 6.71532 12.2006 6.695 12.2934 6.65556C12.3862 6.61613 12.47 6.55839 12.54 6.48581L12 5.96581ZM9.426 18.7878C7.91 17.5928 6.253 16.4258 4.938 14.9458C3.65 13.4938 2.75 11.8008 2.75 9.60281H1.25C1.25 12.2688 2.36 14.3028 3.817 15.9418C5.247 17.5518 7.071 18.8418 8.497 19.9658L9.426 18.7878ZM2.75 9.60281C2.75 7.45281 3.965 5.6488 5.624 4.8898C7.236 4.1528 9.402 4.34781 11.46 6.48581L12.54 5.44681C10.1 2.90981 7.264 2.49081 5 3.5258C2.786 4.53881 1.25 6.89081 1.25 9.60281H2.75ZM8.497 19.9658C9.01 20.3698 9.56 20.7998 10.117 21.1258C10.674 21.4518 11.31 21.7158 12 21.7158V20.2158C11.69 20.2158 11.326 20.0958 10.874 19.8308C10.421 19.5668 9.952 19.2028 9.426 18.7878L8.497 19.9658ZM15.503 19.9658C16.929 18.8408 18.753 17.5528 20.183 15.9418C21.64 14.3018 22.75 12.2688 22.75 9.60281H21.25C21.25 11.8008 20.35 13.4938 19.062 14.9458C17.747 16.4258 16.09 17.5928 14.574 18.7878L15.503 19.9658ZM22.75 9.60281C22.75 6.89081 21.215 4.53881 19 3.5258C16.736 2.49081 13.902 2.90981 11.46 5.44581L12.54 6.48581C14.598 4.3488 16.764 4.1528 18.376 4.8898C20.035 5.6488 21.25 7.45181 21.25 9.60281H22.75ZM14.574 18.7878C14.048 19.2028 13.579 19.5668 13.126 19.8308C12.673 20.0948 12.31 20.2158 12 20.2158V21.7158C12.69 21.7158 13.326 21.4508 13.883 21.1258C14.441 20.7998 14.99 20.3698 15.503 19.9658L14.574 18.7878Z"
                  fill="#94AD04" />
              </svg>
            </button>-->

            <a :href="isAuthenticated ? courseItem?.purchase_link : '/login'" class="main-button flex-grow-1">
              {{ $t('enrollmentButtonText') }}
            </a>
          </div>
        </div>

        <div class="courses-single-info__content-paid mt-30" v-else>
          <div>
            <h3>{{ $t('progressTitle') }}</h3>
            <div class="complete">
              <div class="progress">
                <div class="progress-bar" role="progressbar" :style="{ width: courseItem?.enrollment.progress + '%' }"
                  aria-valuenow="25" aria-valuemin="0" aria-label="progress bar" aria-valuemax="100"></div>
              </div>
              <p class="mt-20 text-end">{{ courseItem?.enrollment.progress }} % Completed</p>
            </div>

            <div class="mt-35 continue-study">
              <span>{{ $t('continueText') }}</span>
              <p>{{ courseItem?.title }}</p>
              <div class="d-flex justify-content-center w-100 mt-20">
                <a :href="courseItem?.resume_link"
                  class="main-button d-flex justify-content-center align-items-center rotate-svg">
                  {{ $t('resumeButton') }}

                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
                    <path
                      d="M0.427734 1.82V12.18C0.427734 12.97 1.29773 13.45 1.96773 13.02L10.1077 7.84C10.7277 7.45 10.7277 6.55 10.1077 6.15L1.96773 0.98C1.29773 0.55 0.427734 1.03 0.427734 1.82Z"
                      fill="white" />
                  </svg>
                </a>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import AOS from "aos";
import RatingComponent from "../common/RatingComponent.vue";
import { getSingleCourse } from "@/Services/api/CoursesService";
export default {
  components: { RatingComponent },
  props: {
    isMenuVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isFixed: false,
      offsetTop: 0,
      couponCode: null,
      courseId: this.$route.params.id,
      purchaseLink: '',
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    /*userData() {
      return this.$store.getters.userData;
    },*/
    courseItem() {
      return this.$store.getters.courseItem;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    formattedLectureTime() {
      const seconds = this.courseItem?.options['lecture_count'] || 0;
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return `${hours} hours and ${minutes} minutes`;
    }
  },
  methods: {
    handleScroll() {
      // Check the current scroll position
      const scrollPosition = window.pageYOffset;
      // Toggle isFixed based on scroll position
      this.isFixed = scrollPosition > this.offsetTop;
    },

    async sendCoupon() {
      if (!this.isAuthenticated) {
        this.$router.push('/login');
      } else {
        try {
          // window.location.reload();
          // Dispatch the action and wait for the updated course details
          let response = await getSingleCourse(this.courseId, this.couponCode);
          // Log the updated course details
          this.$store.commit('setCourseDetails', response.data);
          this.purchaseLink = response.data['purchase_link'];
        } catch (error) {
          console.error("Failed to apply coupon:", error);
        }
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth; // Update window width on resize
    },
  },

  mounted() {
    window.addEventListener('resize', this.updateWindowWidth);

    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });

    const urlParams = new URLSearchParams(window.location.search);
    this.couponCode = urlParams.get('coupon');

    this.offsetTop = this.$refs.courseInfo.offsetTop;
    window.addEventListener("scroll", this.handleScroll);

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
.coupon {
  padding-top: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e6e6e6;
  border-top: 1px solid #e6e6e6;
  margin-bottom: 24px;
}

.favorite {
  border-radius: 8px;
  border: 1px solid var(--Secondary-500, #94ad04);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 12px 20px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;

  &:hover {
    -webkit-transform: translateY(3px);
    -ms-transform: translateY(3px);
    transform: translateY(3px);
  }
}

input[type=text] {
  padding: 10px;
}

.exprience {
  color: var(--Neutral-600, #666) !important;
}

h1 {
  color: var(--Primary-800, #05222e);
  font-family: "Montserrat", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 140%;
}

.course-info {
  color: var(--Neutral-500, #999);
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
}

.button {
  background: #09445d;
  padding: 15px 16px;
  color: #fff;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    transform: translateY(2px);
  }
}

.main-button {
  -webkit-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;

  &:hover {
    background: #05222e !important;
    -webkit-transform: translateY(3px);
    -ms-transform: translateY(3px);
    transform: translateY(3px);
    color: #fff !important;
  }
}

video {
  width: 100%;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.course-headingimage {
  width: 100%;
  height: auto;
  overflow: hidden;
  border-radius: 8px;

  img {
    object-fit: cover;
  }
}

@media screen and (max-width:992px) {
  .course-headingimage {
    width: 100%;
    // height: 397px;
  }
}

.courses-single-info__content-paid {
  border-radius: 8px;
  background: #f6f8f8;
  font-family: "Montserrat", sans-serif;
  padding: 32px 16px;

  h3,
  span,
  p {
    line-height: 140%;
  }

  h3 {
    color: var(--Neutral-800, #333);
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .complete p {
    color: var(--Primary-600, #09445d);
    font-size: 16px;
    font-weight: 500;
  }

  .continue-study {
    span {
      color: var(--Neutral-700, #4d4d4d);
      font-size: 16px;
      font-weight: 400;
    }

    p {
      color: var(--Neutral-800, #333);
      font-size: 20px;
      font-weight: 600;
    }
  }
}

.progress-bar,
.progress {
  height: 6px;
}

.progress-bar {
  border-radius: 20px;
  background: var(--Primary-600, #09445d);
}

.main-button {
  width: 100%;

  &:hover {
    svg {
      path {
        fill: #fff !important;
      }
    }
  }
}
</style>
